import { useEffect, useState } from "react";
import ProjetsMatchesDashboard from "../ProjetsMatchesDashboard";
import ProjectsDashboard from "../ProjectsDashboard";
import LikesReceivedDashboard from "../LikesReceivedDashboard";
import LikesSentDashboard from "../LikesSendDashboard";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTabAppelOffre } from "../../redux/actions/dashboardActions";
import AppelsOffresDashboard from "../AppelsOffresDashboard";
import LikesDonneurOrdreDashboard from "../LikesDonneurOrdreDashboard";
import MatchesDonneurOrdreDashboard from "../MatchesDonneurOrdreDashboard";
import AppelsOffresMatchesDashboard from "../AppelsOffresMatchesDashboard";
import SearchAppelsOffres from "../SearchAppelsOffres";
const MesAppelsOffresDashboard = () => {
    const { selectedMatchDonneurOrdre } = useSelector((state) => state.match);
    const { activeTabAppelOffre } = useSelector((state) => state.dashboard);
    const [menuOpen, setMenuOpen] = useState(false);
    const dispatch = useDispatch();
    const tabStyle = (tab) => ({
        padding: "10px 18px",
        cursor: "pointer",
        borderBottom: activeTabAppelOffre === tab ? "3px solid #007bff" : "3px solid transparent",
        fontWeight: activeTabAppelOffre === tab ? "bold" : "normal"
    });

    const getActiveTabName = () => {
        switch (activeTabAppelOffre) {
            case "trouver":
                return "Trouver un appel d'offre";
            case "likesReceived":
                return "Demandes de matchs reçues";
            case "likesSent":
                return "Demandes de matchs envoyées";
            case "confirmes":
                return "Matchs confirmés";
            default:
                dispatch(setActiveTabAppelOffre("trouver"));
                return "Trouver un appel d'offre";
        }
    }

    useEffect(() => {
        if (selectedMatchDonneurOrdre !== null) {
            dispatch(setActiveTabAppelOffre("confirmes"));
        }
    }, [selectedMatchDonneurOrdre]);

    return (
        <div>
            {!selectedMatchDonneurOrdre && (<h2 style={{textAlign:"center",margin:"10px"}}>Mes Appels d'offres favoris / Trouver mon futur donneur d'ordres</h2>)}
            {/* ======== 🍔 BOUTON BURGER MOBILE ======== */}
            <button className="burger-btn" onClick={() => setMenuOpen(!menuOpen)}>
                {getActiveTabName()}<span>{menuOpen ? "▲" : "▼"}</span>
            </button>

            {/* ======== 🍔 MENU BURGER OUVERT ======== */}
            {menuOpen && (
                <div className="burger-menu">
                    <div className="burger-item" onClick={() => {dispatch(setActiveTabAppelOffre("trouver"));setMenuOpen(false)}}>Trouver un appel d'offre</div>
                    <div className="burger-item" onClick={() => {dispatch(setActiveTabAppelOffre("likesReceived"));setMenuOpen(false)}}>Demandes de matchs reçues</div>
                    <div className="burger-item" onClick={() => {dispatch(setActiveTabAppelOffre("likesSent"));setMenuOpen(false)}}>Demandes de matchs envoyées</div>
                    <div className="burger-item" onClick={() => {dispatch(setActiveTabAppelOffre("confirmes"));setMenuOpen(false)}}>Matchs confirmés</div>
                </div>
            )}
            {/* Onglets */}
            {!selectedMatchDonneurOrdre&&(<div className="desktop-menu">
                <div style={tabStyle("trouver")} onClick={() => dispatch(setActiveTabAppelOffre("trouver"))}>Trouver un appel d'offre</div>
                <div style={tabStyle("likesReceived")} onClick={() => dispatch(setActiveTabAppelOffre("likesReceived"))}>Demandes de matchs reçues</div>
                <div style={tabStyle("likesSent")} onClick={() => dispatch(setActiveTabAppelOffre("likesSent"))}>Demandes de matchs envoyées</div>
                <div style={tabStyle("confirmes")} onClick={() => dispatch(setActiveTabAppelOffre("confirmes"))}>Matchs confirmés</div>
            </div>)}

            {/* Contenus dynamiques */}
            {activeTabAppelOffre === "trouver" && <SearchAppelsOffres />}
            {activeTabAppelOffre === "likesReceived" && <LikesDonneurOrdreDashboard type="received" />}
            {activeTabAppelOffre === "likesSent" && <LikesDonneurOrdreDashboard type="sent" />}
            {activeTabAppelOffre === "confirmes" && <AppelsOffresMatchesDashboard />}
        </div>
    );
};

export default MesAppelsOffresDashboard;
